import React from "react";
import { Layer, Group } from "react-konva";
import CustomLayer from "./Custom.Layer";
import { connect } from "react-redux";
import PencilMode from "../Modes/Pencil.Mode";
import { MODE_TYPE } from "../../store/reducers/mode.reducer";
import { addMode } from "../../store/actions/mode.action";
import createId from "uuid/v1";

class DrawingLayer extends CustomLayer {
  constructor(props) {
    super(props);
    this.currentMode = null;
    this.currentModeData = {};
  }

  handleDataUpdate = data => {
    this.currentModeData = data;
  };

  // ONLY RENDER DRAWING LAYER WHEN USER IS DRAWING
  shouldComponentUpdate(nextProps) {
    // previous data
    const prevModesLength = this.props.modes.length;
    let prevIsMouseDown = this.props.isMouseDown;

    // next data
    const nextModesLength = nextProps.modes.length;
    const nextIsMouseDown = nextProps.isMouseDown;
    const nextModeType = nextProps.currentModeType;

    //console.log({ prevModesLength, nextModesLength });

    // if (prevModesLength.length != nextModesLength) return true;

    // if (nextModeType === MODE_TYPE.ARROW_MODE) return false;

    // if (prevIsMouseDown === nextIsMouseDown) return false;

    return true;
  }

  componentDidUpdate(prevProps) {
    // let prevIsMouseDown = prevProps.isMouseDown;

    let currentModeType = this.props.currentModeType;
    // if (currentModeType === MODE_TYPE.ARROW_MODE) return;

    // //console.log("current mouse position ");
    let currentIsMouseDown = this.props.isMouseDown;

    // if (prevIsMouseDown === currentIsMouseDown) return;

    if (currentIsMouseDown) {
      this.onDrawingStarted();
      return this.addModeToDrawingLayer(currentModeType);
    }

    this.removeModeFromDrawingLayer(currentModeType);
    this.resetCurrentMode();
    this.onDrawingFinished();
  }

  addModeToDrawingLayer(modeType) {
    DrawingLayer.isDrawing = true;
    switch (modeType) {
      case MODE_TYPE.PENCIL_MODE:
        return (this.currentMode = (
          <PencilMode
            store={this.props.store}
            onDataUpdate={this.handleDataUpdate}
          ></PencilMode>
        ));

      default:
        return (this.currentMode = null);
    }
  }

  resetCurrentMode() {
    this.currentMode = null;
    this.currentModeData = {};
  }

  removeModeFromDrawingLayer(modeType) {
    DrawingLayer.isDrawing = false;

    if (modeType === MODE_TYPE.ARROW_MODE) return;
    const id = createId();
    if (typeof this.currentModeData.points === "undefined") return;
    this.props.dispatch(addMode(this.currentModeData, id, modeType));
  }

  drawCurrentMode() {
    // console.log("current mode ....");
    // console.log(this.currentMode);
    return this.currentMode === null ? <Group></Group> : this.currentMode;
  }

  drawModes() {
    // TODO HANDLE VARIOUS MODES HERE
    return this.props.modes.map(mode => {
      return (
        <PencilMode
          store={this.props.store}
          data={{ ...mode.data, isActive: false }}
          key={mode.id}
        ></PencilMode>
      );
    });
  }

  render() {
    return (
      <Layer>
        {/* <IconMode store={store}></IconMode> */}
        {this.drawCurrentMode()}
        {this.drawModes()}
      </Layer>
    );
  }
}

export default connect(DrawingLayer.mapStateToProps)(DrawingLayer);
